// Route-tab strip for the admin route-tab groups (admin menu simplification,
// part 2 — 2026-10-05). AdminShell renders it above the page, so the merged
// screens keep their own addresses, filters and deep links. The strip shows on
// the tab routes themselves only — not on detail pages under them.

import { useRouterState } from '@tanstack/react-router'
import { RouteTabs } from '../../components/ui/route-tabs'
import { useT } from '../../i18n'
import { adminHubsI18n } from '../../i18n/admin/hubs'
import { ADMIN_HUBS } from './admin-hubs-config'

/** `hiddenTabs`: tab routes the viewer may not open (e.g. Sales Goals without
 *  its permission) — left out of the strip. */
export function AdminHubTabs({ hiddenTabs = [] }: { hiddenTabs?: string[] }) {
  const t = useT(adminHubsI18n)
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const path = pathname.replace(/\/+$/, '')
  // The strip also shows on Invitations (UX-028, 2026-11-02: Leads → Invitations
  // → Applications read as one flow); Invitations keeps its own page header.
  const hub = ADMIN_HUBS.find((h) => h.tabs.some((tab) => tab.to === path))
  if (!hub) return null
  return (
    <RouteTabs
      title={hub.title(t)}
      activeTo={path}
      tabs={hub.tabs
        .filter((tab) => !hiddenTabs.includes(tab.to))
        .map((tab) => ({ to: tab.to, label: tab.label(t) }))}
    />
  )
}
